<template>
  <div class="enkai__faq__container">
    <h2 class="enkai__faq__heading">{{ prefectureName }}の会場探しでよくある質問</h2>
    <div class="enkai__faq__content">
      <h3 class="enkai__faq__question">{{ prefectureName }}で宴会・パーティーの貸切予約におすすめの会場はどこですか？</h3>
      <div class="enkai__faq__answer">
        {{ prefectureName }}にはグルメプラスおすすめのレストランが{{ shopsCount }}件あり、その中でも宴会・パーティーの貸切予約におすすめのレストランは、<span v-for="(shop, index) in recommendedShops" :key="'recommendedShops' + shop.id">
          <a :href="`${shop.detail_url}`">{{ shop.name }}</a><span v-if="index < recommendedShops.length - 1">、</span>
        </span>などがあります。<br>
        {{ prefectureName }}で宴会・パーティー会場の貸切予約を行う場合は、<span v-for="(area, index) in recommendedAreas" :key="area.id">
          <a :href="`./A${area.id}/`">{{ area.name }}</a><span v-if="index < recommendedAreas.length - 1">や</span>
        </span>などの人気エリアから探しつつ、交通アクセスの良い場所を選択するのがおすすめです。
      </div>
      <template v-if="this.recommendedMaxCapacityShops.length > 0">
        <h3 class="enkai__faq__question">{{ prefectureName }}で大人数の貸切予約におすすめのパーティー会場はありますか？</h3>
        <div class="enkai__faq__answer">
          {{ prefectureName }}で大人数の貸切予約におすすめの宴会場は、<span v-for="(shop, index) in recommendedMaxCapacityShops" :key="'recommendedMaxCapacityShops' + shop.id">
            <a :href="`${shop.detail_url}`">{{ shop.name }}</a><span v-if="index < recommendedMaxCapacityShops.length - 1">、</span>
          </span>などがあります。<br>
          <span v-for="(shop, index) in recommendedMaxCapacityShops" :key="'recommendedMaxCapacityShopsDetail' + shop.id">
            <a :href="`${shop.detail_url}`">{{ shop.name }}</a>は最大{{ shop.maxCapacity > 0 ? shop.maxCapacity : '--' }}人<span v-if="index < recommendedMaxCapacityShops.length - 1">、</span>
          </span>での貸切予約が可能であり、{{ prefectureName }}で大人数の宴会やパーティーを行う際におすすめです。
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        prefectureName: {
            type: String,
            required: true
        },
        shopsCount: {
            type: Number,
            required: true,
        },
        shops: {
            type: Array,
            required: true,
        },
        areasInPrefecture: {
            type: Array,
            required: true,
        }
    },
    data() {
      return {
          recommendedShops: [],
          recommendedAreas: [],
          recommendedMaxCapacityShops: [],
      };
    },
    created() {
        this.createRecommendedShops();
        this.createRecommendedAreas();
        this.createRecommendedMaxCapacityShops();
    },
    watch: {
        shops: function() {
            this.createRecommendedShops();
        },
        areasInPrefecture: function() {
            this.createRecommendedAreas();
        }
    },
    methods: {
        createRecommendedShops: function() {
            this.recommendedShops = this.shops.slice(0, 3);
        },
        createRecommendedAreas: function() {
            this.recommendedAreas = this.areasInPrefecture.slice(0, 2);
        },
        createRecommendedMaxCapacityShops: function() {
            const ranks = [...new Set(this.shops.map(shop => shop.rank))];
            this.recommendedMaxCapacityShops = ranks
                .reduce((result, rank) => {
                    const rankShops = this.shops.filter(shop => shop.rank === rank);
                    const rankedShopsMaxCapacity = rankShops.map(shop => {
                        return {...shop, maxCapacity: Math.max(shop.max_count || 0, shop.max_standing_count || 0)};
                    });

                    const sortedRankedShops = rankedShopsMaxCapacity.sort((shopA, shopB) => shopB.maxCapacity - shopA.maxCapacity);
                    return result.concat(sortedRankedShops);
                }, [])
                .slice(0, 3);
          }
    }
};
</script>
